let view = null;

export default {
	namespace: 'template-shop',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: AllProductsView } = await import(
			/* webpackChunkName: "all-products-view" */ '../../templates/AllProductsView'
		);
		view = new AllProductsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
